import { makeUrl } from '@returnoninvestment/hooks';
import axios from 'axios';
import { getUserInformationFromLocalStorage } from '../../contexts/user';

const makeHeaders = () => {
    const { username } = getUserInformationFromLocalStorage();
    return {
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_API_KEY,
        'x-username': username,
    };
};

export function AxiosGet(route, params) {
    return axios({
        method: 'GET',
        url: makeUrl(`/api/${route}`, params),
        headers: makeHeaders(),
    });
}

export function AxiosPost(route, params, data) {
    return axios({
        method: 'POST',
        url: makeUrl(`/api/${route}`, params),
        headers: makeHeaders(),
        data,
    });
}

export function AxiosDelete(route, params, data) {
    return axios({
        method: 'DELETE',
        url: makeUrl(`/api/${route}`, params),
        headers: makeHeaders(),
        data,
    });
}

export function AxiosPut(route, params, data) {
    return axios({
        method: 'PUT',
        url: makeUrl(`/api/${route}`, params),
        headers: makeHeaders(),
        data,
    });
}

export function AxiosAuthLink(route) {
    return axios({
        method: 'GET',
        url: route,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}
